import { styled, type Theme } from '@biome-design-system/styles';

export const NoResultsContainer = styled('div')(
  ({ theme }: { theme: Theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(4),
    gap: theme.spacing(5),
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'flex-start'
    }
  })
);

export const MainContentContainer = styled('div')({
  flex: '2 1 0'
});

export const SidebarContainer = styled('div')(
  ({ theme }: { theme: Theme }) => ({
    flex: '1 1 0',
    minWidth: '300px',
    [theme.breakpoints.up('md')]: {
      maxWidth: '400px'
    }
  })
);
